import React from "react";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { Line as LineChart } from "react-chartjs-2";

import { registerBackgroundColourService } from "../lib/chartUtils";

registerBackgroundColourService();

type SalesTodayChartProps = {
  classes: Object,
  data: Array<Object>,
};

const basicChartOptions = {
  maintainAspectRatio: false,
  chartArea: {
    backgroundColor: "rgba(245, 245, 245, 0.4)",
  },
};

const smallOptions = {
  scales: {
    yAxes: [
      {
        ticks: {
          stepSize: 1,
          beginAtZero: true,
        },
      },
    ],
  },
};

const calcOptions = data => {
  const max = data.reduce((a, b) => Math.max(a, b.sales), 0);
  if (max < 5) {
    const options = {
      ...basicChartOptions,
      ...smallOptions,
    };
    return options;
  }
  return basicChartOptions;
};

const dateToHourSpan = date => {
  const time1 = new Date(date);
  const time2 = new Date(date);
  time2.setHours(time2.getHours() + 1);

  const m1 = moment(time1);
  const m2 = moment(time2);
  return `${m1.format("HH:mm")}-${m2.format("HH:mm")}`;
};

const mapData = data => ({
  labels: data.map(d => dateToHourSpan(d.date)),
  datasets: [
    {
      label: "Ventes à l'heure",
      data: data.map(d => d.sales),
      backgroundColor: "rgba(102,192,255,0.3)",
      borderColor: "rgba(102,192,255,0.6)",
    },
  ],
});

const SalesTodayChart = ({ classes, data }: SalesTodayChartProps) =>
  data.length > 0 && (
    <div className={classes.container}>
      <LineChart
        data={mapData(data)}
        options={calcOptions(data)}
        height={400}
      />
    </div>
  );

const styles = () => ({
  container: {
    marginTop: 20,
    marginLeft: 10,
    marginRight: 10,
    maxWidth: 800,
  },
});

export default withStyles(styles)(SalesTodayChart);



// WEBPACK FOOTER //
// ./src/components/salesTodayChart.js